function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
const SvgWifiOff = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none",
  viewBox: "0 0 18 18",
  "data-animate": props.isAnimate || false,
  "data-interactive": props.animateOnInteraction || false
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: props.color || 'currentColor',
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m1.667 1.667 14.666 14.666m-4.186-7.96c.546.267 1.056.6 1.52.994m-9.334 0A7.293 7.293 0 0 1 7.78 7.773m.36-3.406A10.667 10.667 0 0 1 16.053 7M1.947 7A10.606 10.606 0 0 1 5.08 5.08m1.607 6.66a4 4 0 0 1 4.633 0M9 14.333h.007"
}));
export default SvgWifiOff;